<template lang="pug">
yz-filter-menu(:label="$t('name')" :is-active="!!selectedOption" :display-value="displayValue" @clear="onClear" @apply="onApply")
  .pa-4
    y-select.mb-2(:items="options" item-text="name" item-value="id" v-model="option" small attach)
    .d-flex.align-start
      v-icon.mx-2(size="16" color="primary") $yzi-corner-down-right
      v-text-field.round-xl(v-model="value" hide-details outlined dense :placeholder="$t('type_a_value')")
</template>

<script>
export default {
  props: {
    filter: { type: Object, default: () => ({}) },
    checkInitialValue: { type: Boolean, default: false }
  },
  data: () => ({
    option: 'name__contains',
    value: null,
    options: [
      { id: 'name', name: 'Is' },
      { id: 'name__ne', name: 'Is not' },
      { id: 'name__contains', name: 'Contains' },
      { id: 'name__exclude', name: 'Does not contains' },
      { id: 'name__startswith', name: 'Starts with' },
      { id: 'name__endswidth', name: 'Ends with' }
    ],
    selectedOption: null,
    selectedValue: null
  }),
  computed: {
    displayValue () {
      if (!this.selectedOption) return ''
      const opt = this.options.find(o => o.id === this.selectedOption)
      return `${opt ? opt.name : ''} ${this.selectedValue}`
    }
  },
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) this.clearData()
      }
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      if (this.checkInitialValue && this.filter.key) {
        this.selectedOption = this.filter.key
        this.option = this.filter.key
        this.value = this.filter.value
        this.selectedValue = this.filter.value
      }
    },
    onClear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.value = null
      this.selectedOption = null
      this.selectedValue = null
    },
    onApply () {
      if (!this.value) return
      this.selectedOption = this.option
      this.selectedValue = this.value
      this.$emit('update:filter', { key: this.option, value: this.value })
    }
  }
}
</script>
